import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  SelectOption
} from '../../../types/sale/creditNote/CreditNoteSaleLookup';
import {
  CreditNoteSaleDetail,
  CreditNoteSaleProductSummary
} from '../../../types/sale/creditNote/CreditNoteSaleDetail';

// ✅ Estado inicial predefinido para evitar `null` en selectedSaleDetail
const initialSelectedSaleDetail: CreditNoteSaleDetail = {
  id: 0,
  documentNumber: '',
  saleDate: '',
  customerName: '',
  subtotal: 0,
  total: 0,
  paymentCondition: '',
  products: [], // 👈 importante
};

interface CreditNoteSaleLookupState {
  filteredDocuments: SelectOption[];
  selectedSaleDetail: CreditNoteSaleDetail;
  paginator: { number: number; size: number; totalElements: number; totalPages: number; first: boolean; last: boolean };
}

const initialState: CreditNoteSaleLookupState = {
  filteredDocuments: [],
  paginator: { number: 0, size: 10, totalElements: 0, totalPages: 0, first: true, last: true },
  selectedSaleDetail: initialSelectedSaleDetail, // 👈 usamos el estado base
};

const creditNoteSaleLookupSlice = createSlice({
  name: 'creditNoteSaleLookup',
  initialState,
  reducers: {
    setFilteredDocuments(state, action: PayloadAction<SelectOption[]>) {
      state.filteredDocuments = action.payload;
    },
    setLookupPaginator(state, action: PayloadAction<CreditNoteSaleLookupState['paginator']>) {
      state.paginator = action.payload;
    },
    clearFilteredDocuments(state) {
      state.filteredDocuments = [];
      state.paginator = { number: 0, size: 10, totalElements: 0, totalPages: 0, first: true, last: true };
    },
    setSelectedSaleDetail(state, action: PayloadAction<CreditNoteSaleDetail>) {
      state.selectedSaleDetail = action.payload;
    },
    clearSelectedSaleDetail(state) {
      state.selectedSaleDetail = initialSelectedSaleDetail;
    },
    updateReturnInfoList(
      state,
      action: PayloadAction<{
        productId: number;
        returnedQuantity: number;
        remainingQuantity: number;
        canBeReturned: boolean;
      }[]>
    ) {
      const updates = action.payload;
      state.selectedSaleDetail.products.forEach((product) => {
        const match = updates.find((u) => u.productId === product.productId);
        if (match) {
          product.returnedQuantity = match.returnedQuantity;
          product.remainingQuantity = match.remainingQuantity;
          product.canBeReturned = match.canBeReturned;
        }
      });
    },
    updateProductsFromBalance(
      state,
      action: PayloadAction<CreditNoteSaleProductSummary[]>
    ) {
      state.selectedSaleDetail.products = action.payload;
    },
  },
});

export const {
  setFilteredDocuments,
  setLookupPaginator,
  clearFilteredDocuments,
  setSelectedSaleDetail,
  clearSelectedSaleDetail,
  updateReturnInfoList,
  updateProductsFromBalance,
} = creditNoteSaleLookupSlice.actions;

export default creditNoteSaleLookupSlice.reducer;
